import { render, staticRenderFns } from "./Lgx249112018676613120.vue?vue&type=template&id=068e38f9&scoped=true&"
import script from "./Lgx249112018676613120.vue?vue&type=script&lang=js&"
export * from "./Lgx249112018676613120.vue?vue&type=script&lang=js&"
import style0 from "./Lgx249112018676613120.vue?vue&type=style&index=0&id=068e38f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e38f9",
  null
  
)

export default component.exports